import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterLabel = ({ number, title, light = false }) => (
  <div className="flex items-baseline gap-4">
    <span
      className={`font-heading text-sm font-bold tracking-widest ${light ? "text-[#C5A059]" : "text-[#C5A059]"}`}
    >
      {number}
    </span>
    <span className="w-10 h-px bg-[#C5A059] self-center" />
    <span
      className={`text-[11px] font-semibold tracking-[0.3em] uppercase ${
        light ? "text-white/70" : "text-[#4B5563]"
      }`}
    >
      {title}
    </span>
  </div>
);
